import React from 'react';

import { Brief } from '../Brief/Brief';
import { Layout } from '../Layout/Layout';

export interface MatchChecklistProps {
  children: React.ReactNode;
  name: string;
}

export const MatchChecklist = ({ children, name }: MatchChecklistProps) => {
  return (
    <Layout name="checklist" direction="vertical">
      <Brief
        name="match-checklist-brief"
        briefMaxChildren={5}
        key={`${name}-brief`}
      >
        {children}
      </Brief>
    </Layout>
  );
};
